import { render, staticRenderFns } from "./AppTel.vue?vue&type=template&id=c1b4806c&scoped=true"
import script from "./AppTel.vue?vue&type=script&lang=js"
export * from "./AppTel.vue?vue&type=script&lang=js"
import style0 from "./AppTel.vue?vue&type=style&index=0&id=c1b4806c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1b4806c",
  null
  
)

export default component.exports